<template>
  <div class="app-container">
    <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    
    <div v-else>
      <div class="homepage">
        <!-- Header Section -->
        <header class="app-header">
          <div class="header-content">
            <div class="school-branding">
              <h1 class="school-name">Kalapini Sangeet Vidhyalay</h1>
              <p class="school-subtitle">Pandharpur (Estd: 1978)</p>
            </div>
            
            <div class="user-welcome">
              <div class="user-avatar">
                <i class="fas fa-user-circle"></i>
              </div>
              <div class="user-info">
                <h4>Hello, {{ user_details.name }}</h4>
                <p>Welcome back!</p>
              </div>
            </div>
          </div>
        </header>

        <!-- Dashboard Content -->
        <main class="dashboard-container">
          <div class="dashboard-grid">
            <!-- Row 1 -->

            <!-- Row 2 -->
            <div class="card-row" v-if="'Admin'==user_details.role">
              <router-link to="AddStaff" class="card-link">
                <div class="dashboard-card staff-card">
                  <div class="card-icon">
                    <i class="fas fa-chalkboard-teacher"></i>
                  </div>
                  <div class="card-content">
                    <h3>Staff Management</h3>
                    <p>Manage teaching staff</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>

              <router-link to="addexamview">
                <div class="dashboard-card class-card">
                  <div class="card-icon">
                    <i class="fas fa-chalkboard"></i>
                  </div>
                  <div class="card-content">
                    <h3>Manage Exam</h3>
                    <p>Create and organize exam</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>
               <router-link to="seassionview" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                  <h3>Seassion</h3>
                  <p>Add Seassion Here</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>
               <router-link to="StudentView" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                  <h3>Students</h3>
                  <p>Add Students Here</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link> 
              <router-link to="ClassView" class="card-link">
                <div class="dashboard-card attendance-card">
                  <div class="card-icon">
                    <i class="fas fa-calendar-check"></i>
                  </div>
                  <div class="card-content">
                    <h3>Student Attendance</h3>
                    <p>Mark and view daily attendance</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>

              <router-link to="ReportView" class="card-link">
                <div class="dashboard-card report-card">
                  <div class="card-icon">
                    <i class="fas fa-chart-pie"></i>
                  </div>
                  <div class="card-content">
                    <h3>Attendance Report</h3>
                    <p>Generate detailed reports</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>
            </div>

            <!-- Row 3 -->
            <div class="card-row" v-if="'Admin'==user_details.role">
              <!-- <router-link to="manageexamview" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                    <h3>Exam Management</h3>
                    <p>Manage exam records</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link> -->

              <!-- <div class="dashboard-card assign-card" @click="navToAssignClass">
                <div class="card-icon">
                  <i class="fas fa-tasks"></i>
                </div>
                <div class="card-content">
                  <h3>Assign Class</h3>
                  <p>Assign classes to teachers</p>
                </div>
                <div class="card-arrow">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div> -->




   <router-link to="subjectview" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                  <h3>Subject</h3>
                  <p>Add Subject Here</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>


                 <router-link to="examview" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                  <h3>Exam</h3>
                  <p>Add Exam Here</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>

                   <router-link to="questionview" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                  <h3>Question</h3>
                  <p>Add Question Here</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>


              
                  


                 <router-link to="accountingview" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                  <h3>Accounting</h3>
                  <p>Add Accounting Here</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>

                <router-link to="imagegallary" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                  <h3>Image Gallary</h3>
                  <p>Add Image Gallary</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>


                <router-link to="videogallary" class="card-link">
                <div class="dashboard-card student-card">
                  <div class="card-icon">
                    <i class="fas fa-user-graduate"></i>
                  </div>
                  <div class="card-content">
                  <h3>Video Gallary</h3>
                  <p>Add Video Gallary</p>
                  </div>
                  <div class="card-arrow">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </router-link>











            </div>
          </div>
        </main>

        <!-- Bottom Navigation -->
        <nav class="bottom-nav">
          <router-link to="/" class="nav-item active">
            <i class="fas fa-home"></i>
            <span>Home</span>
          </router-link>
          <router-link to="ClassView" class="nav-item">
            <i class="fas fa-user"></i>
            <span>Attendance</span>
          </router-link>
          <router-link to="ReportView" class="nav-item">
            <i class="fas fa-chart-bar"></i>
            <span>Reports</span>
          </router-link>
          <div class="nav-item" @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script> 
import axios from "@/plugins/axios";  
import { ref } from 'vue';

export default {
  name: 'HomeView',
  data() {
    return {
      profile: [],   
      isBranchAllowed: true,
      isUserAllowed: true,
      isbutton: false,
      loading: false,
      error: null,
      isUserLogged: false,
      user_details: [],
      total_booking: 0,
      total_amt: 0,
      orderList: [],
      language: this.getLocalStorageArray('lang'),
      show_del_list: true,
      laundry_details: {"acc_type": 1}
    }
  },
  mounted() {
    this.getHomeBasic();
  },
  methods: {
    initializeHomeContent() {
      // Initialization logic if needed
    },
    
    navTo(route) {
      this.$router.push(route);
    },
    
    navToAssignClass() {
      // You can implement navigation for assign class here
      alert("Assign Class functionality would be implemented here");
    },
    
    checkUserLogged() {
      if (!this.isUserLogged) {
        this.$router.push({ name: 'register' });
      } else if (this.isUserLogged) {
        this.$router.push({ name: 'form' });
      }
    },
    
    checkUserprofile() {
      if (!this.isUserLogged) {
        this.$router.push({ name: 'register' });
      } else if (this.isUserLogged) {
        this.$router.push({ name: 'profile' });
      }
    },
    
    logout() {
      // Implement logout functionality
      localStorage.removeItem("token");
      this.$router.push('/login');
    },
 
    async getHomeBasic() {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;
        axios.post("getUserDetails").then((response) => {
          if (response.data.logged) {
            self.isUserLogged = response.data.logged;
            self.user_details = response.data.userdeatils;
            self.language = response.data.language;
            
            if (self.laundry_details?.expired == 1) {
              localStorage.removeItem("token"); 
              window.location.replace("/");
            }
            
            localStorage.setItem('lang', response.data.language);
          } else {
            localStorage.removeItem("token"); 
            self.$router.push('/');
          } 
        }).then(() => {
          self.initializeHomeContent();
        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    getLocalStorageArray(key) {
      let data = localStorage?.getItem(key);
      try {
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error("Error parsing localStorage data", e);
        return [];
      }
    }
  }
}
</script>

<style scoped>

.app-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #0056c2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.app-header {
  background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
  color: white;
  padding: 20px 15px;
  border-radius: 0 0 25px 25px;
  box-shadow: 0 4px 12px rgba(0, 86, 194, 0.15);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.school-branding {
  text-align: left;
}

.school-name {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.5px;
}

.school-subtitle {
  font-size: 14px;
  margin: 5px 0 0;
  opacity: 0.9;
}

.user-welcome {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  font-size: 36px;
}

.user-info h4 {
  margin: 0;
  font-size: 16px;
}

.user-info p {
  margin: 2px 0 0;
  font-size: 12px;
  opacity: 0.8;
}

.dashboard-container {
  padding: 20px 15px 80px;
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-row {
  display: grid;
  grid-template-columns:1fr 1fr 1fr;
  gap: 16px;
}

.card-link {
  text-decoration: none;
  color: inherit;
}

.dashboard-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  height: 100px;
}

.dashboard-card:active {
  transform: scale(0.98);
}

.dashboard-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
}

.attendance-card::before { background: #4caf50; }
.report-card::before { background: #ff9800; }
.staff-card::before { background: #9c27b0; }
.class-card::before { background: #2196f3; }
.student-card::before { background: #e91e63; }
.assign-card::before { background: #607d8b; }

.card-icon {
  font-size: 28px;
  margin-right: 15px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  flex-shrink: 0;
}

.attendance-card .card-icon { background: rgba(76, 175, 80, 0.15); color: #4caf50; }
.report-card .card-icon { background: rgba(255, 152, 0, 0.15); color: #ff9800; }
.staff-card .card-icon { background: rgba(156, 39, 176, 0.15); color: #9c27b0; }
.class-card .card-icon { background: rgba(33, 150, 243, 0.15); color: #2196f3; }
.student-card .card-icon { background: rgba(233, 30, 99, 0.15); color: #e91e63; }
.assign-card .card-icon { background: rgba(96, 125, 139, 0.15); color: #607d8b; }

.card-content {
  flex: 1;
}

.card-content h3 {
  margin: 0 0 5px;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

.card-content p {
  margin: 0;
  font-size: 12px;
  color: #7f8c8d;
}

.card-arrow {
  color: #bdc3c7;
  font-size: 16px;
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  justify-content: space-around;
  padding: 12px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #7f8c8d;
  font-size: 12px;
  transition: color 0.3s;
}

.nav-item.active {
  color: #0056c2;
}

.nav-item i {
  font-size: 20px;
  margin-bottom: 4px;
}

.nav-item span {
  font-size: 11px;
}

@media (max-width: 480px) {
  .card-row {
    grid-template-columns: 1fr;
  }
  
  .header-content {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
  
  .user-welcome {
    justify-content: center;
  }
  
  .school-name {
    font-size: 20px;
  }
}
</style>